<template>
  <el-popover
    placement="top-start"
    trigger="click"
    width="353"
    v-bind="$attrs"
    ref="popover"
  >
    <template v-slot>
      <div class="d-flex justify-content-between mb-2">
        <div>Click to insert into the cursor position:</div>
        <div>
          <button
          @click="close"
          type="button"
          class="btn line-height-10 p-0 bg-gray-hover-200"
        >
          <i class="fas fa-times fa-sm fa-fw"></i>
        </button>
        </div>
      </div>
      <div class="text-left">
        <item v-for="item in items" :key="item.key" :value="item" @select="onSelect"></item>
      </div>
    </template>
    <span slot="reference">
            <slot>
                Placeholders
            </slot>
        </span>
  </el-popover>
</template>

<script>
import Item from './item';

export default {
  components: {
    Item,
  },

  props: {
    multiple: {
      type: Boolean,
      default: true,
    }
  },

  data() {
    return {
      items: [
        {key: 1, value: '[[contact_first_name]]'},
        {key: 2, value: '[[contact_last_name]]'},
        {key: 3, value: '[[contact_full_name]]'},
        {key: 4, value: '[[contact_phone_number]]'},
        {key: 5, value: '[[outgoing_number_phone_number]]'},
        {key: 6, value: '[[outgoing_number_name]]'},
      ],
    };
  },

  methods: {
    onSelect(value) {
      this.$emit('select', value);
      !this.multiple && this.close();
    },

    close() {
      this.$refs.popover.doClose();
    },
  },
}
</script>

